import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { Menu, IconButton } from "@mui/material";
import SubMenuTitleContainer from "./SubMenuTitle.styles";
import Can from "components/Common/Can/Can";

type Props = {
    text: string;
    permissions?: string[];
    children?: React.ReactNode;
};

export default function SubMenuTitle({
    text,
    permissions = [],
    children,
}: Props) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Can
            yes={
                <SubMenuTitleContainer>
                    <p className={"text"}>{text}</p>
                    <div className={"separator"} />
                    {children && (
                        <>
                            <IconButton
                                className="menuIcon"
                                size="small"
                                onClick={handleClick}
                                aria-label="more options"
                            >
                                <FontAwesomeIcon icon={faEllipsisV} />
                            </IconButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                onClick={handleClose}
                            >
                                {children}
                            </Menu>
                        </>
                    )}
                </SubMenuTitleContainer>
            }
            permissions={permissions}
        />
    );
}
